import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ChevronRight, Home } from "lucide-react";
import { SITE_URL } from "../data/business";

export default function Breadcrumbs({ items = [] }) {
  const { pathname } = useLocation();
  const itemListElement = [
    { "@type": "ListItem", position: 1, name: "Home", item: `${SITE_URL}/` },
    ...items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 2,
      name: it.label,
      item: `${SITE_URL}${it.to || pathname}`,
    })),
  ];
  const schema = { "@context": "https://schema.org", "@type": "BreadcrumbList", itemListElement };

  return (
    <nav aria-label="Breadcrumb" className="text-sm" data-testid="breadcrumbs">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
      <ol className="flex items-center flex-wrap gap-1 text-slate-500">
        <li>
          <Link to="/" className="inline-flex items-center gap-1 hover:text-[#54616E]" data-testid="breadcrumb-home">
            <Home className="w-3.5 h-3.5" /> Home
          </Link>
        </li>
        {items.map((it, i) => (
          <li key={`${it.label}-${i}`} className="flex items-center gap-1">
            <ChevronRight className="w-3.5 h-3.5 text-slate-400" />
            {it.to && i < items.length - 1 ? (
              <Link to={it.to} className="hover:text-[#54616E]">{it.label}</Link>
            ) : (
              <span className="text-[#1A1D21] font-medium">{it.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
